(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('products-loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zandman-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initZt(root) {
      if (!root || root.dataset.ztReady === 'true') return;
      root.dataset.ztReady = 'true';
      root.classList.add('zt-js');

      var track = root.querySelector('[data-zt-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.zt-card'));
      var arrowsWrap = root.querySelector('[data-zt-arrows]');
      var prev = root.querySelector('[data-zt-arrow][data-direction="prev"]');
      var next = root.querySelector('[data-zt-arrow][data-direction="next"]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-zt-dot]'));
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;

      /* Read more: clamp long reviews, re-checked when card widths change */
      function measure(card) {
        var text = card.querySelector('.zt-card__text');
        var btn = card.querySelector('.zt-card__more');
        if (!text || !btn || btn.getAttribute('aria-expanded') === 'true') return;
        text.classList.add('is-clamped');
        var clipped = text.scrollHeight > text.clientHeight + 2;
        if (!clipped) text.classList.remove('is-clamped');
        btn.hidden = !clipped;
      }
      cards.forEach(function (card) {
        var text = card.querySelector('.zt-card__text');
        var btn = card.querySelector('.zt-card__more');
        if (!text || !btn) return;
        btn.addEventListener('click', function () {
          var open = text.classList.toggle('is-clamped') === false;
          btn.textContent = open ? 'Show less' : 'Read more';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        measure(card);
      });

      if (cards.length < 2) return;

      function pos(i) { return cards[i].offsetLeft - cards[0].offsetLeft; }
      function maxScroll() { return track.scrollWidth - track.clientWidth; }
      function perView() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        var stepW = cards[0].offsetWidth + gap;
        return Math.max(1, Math.floor((track.clientWidth + gap + 2) / stepW));
      }
      function update() {
        var overflow = track.scrollWidth > track.clientWidth + 2;
        root.classList.toggle('zt--overflow', overflow);
        if (arrowsWrap) arrowsWrap.hidden = !overflow;
        var x = track.scrollLeft;
        var max = maxScroll();
        var atEnd = x >= max - 2;
        if (prev) prev.disabled = !overflow || x <= 2;
        if (next) next.disabled = !overflow || atEnd;
        var best = 0;
        var dist = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(pos(i) - x);
          if (d < dist) { dist = d; best = i; }
        });
        if (overflow && atEnd) best = Math.max(best, cards.length - perView());
        current = best;
        dots.forEach(function (d, i) {
          if (i === best) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }
      function goTo(index) {
        var i = Math.max(0, Math.min(cards.length - 1, index));
        track.scrollTo({ left: Math.min(pos(i), maxScroll()), behavior: reduce ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { goTo(current - perView()); });
      if (next) next.addEventListener('click', function () { goTo(current + perView()); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.ztDot, 10)); });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (!root.classList.contains('zt--overflow')) return;
        e.preventDefault();
        goTo(current + (e.key === 'ArrowRight' ? 1 : -1));
      });

      var ticking = false;
      function schedule() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      }
      track.addEventListener('scroll', schedule, { passive: true });

      var lastWidth = 0;
      function onResize() {
        var w = track.clientWidth;
        if (w !== lastWidth) {
          lastWidth = w;
          cards.forEach(measure);
        }
        schedule();
      }
      if ('ResizeObserver' in window) {
        new ResizeObserver(onResize).observe(track);
      } else {
        window.addEventListener('resize', onResize);
      }
      window.addEventListener('load', onResize);

      root.addEventListener('shopify:block:select', function (e) {
        var i = cards.indexOf(e.target);
        if (i > -1) goTo(i);
      });

      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-zt]').forEach(initZt);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
